module.exports = __webpack_public_path__ + "static/media/ic_right.073f2704.png";